import * as d3 from 'd3';
import { TDrawModel } from '../../draw.model';
import { drawHeader } from './header.tasks';
import { drawBody } from './body.tasks';
import { drawLefNav } from './left-nav.task';
import { drawBackground } from './background.tasks';
import { drawForeground } from './foreground.tasks';
import { DRAW_LINKS } from './link.tasks';

const drawTimeline = (drawModel: TDrawModel) => {
  return d3
    .select(drawModel.domRef)
    .selectAll('.timeline-wrapper')
    .data([drawModel])
    .join('div')
    .style('width', drawModel.width + 'px')
    .style('height', drawModel.height + 'px')
    .style('overflow', 'scroll')
    .style('position', 'relative')
    .classed('timeline-wrapper', true);
};

export type TTimelieWrapper = ReturnType<typeof drawTimeline>;

const drawContent = (drawModel: TDrawModel, body: ReturnType<typeof drawBody>) => {
  return body
    .selectAll('.content')
    .data([drawModel])
    .join('g')
    .classed('content', true)
    .attr('width', drawModel.innerWidth);
};

export const DRAW_TASKS = {
  drawTimeline,
  drawHeader,
  drawBody,
  drawBackground,
  drawForeground,
  drawLefNav,
  drawContent,
  ...DRAW_LINKS,
};
